import { ApiCore } from '@/services/api/utils/core.js'
import axios from 'axios';
import { handleResponse, handleError } from '@/services/api/utils/response.js'
import { apiProvider } from './utils/provider';

const url = 'v1/transactionRequest'


const api = new ApiCore({
	index: true,
	findOne: true,
	url
})

api.approve = (id) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${id}/approve`)
		.then(handleResponse)
		.catch(handleError);
}

api.reject = (id, payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${id}/reject`, payload)
		.then(handleResponse)
		.catch(handleError);
};

export default api;
